import apiClient from "../apiClient";
import { CommonApiResponse } from "../../Controllers/Types/ApiResponse";
import { baseURL } from "../ApiConstant";

// get brand list
export const getFSBrandList = async (
    category: 'Kitchen' | 'Paint',
    sub_category?: 'Type' | 'Base Units' | 'Wall Units' | 'Worktop' | 'Door' | 'Handle' | 'Appliances' | 'Paint' | null
) => {
    try {
        const formData = new FormData();
        formData.append("category", category);

        if (sub_category) {
            formData.append("sub_category", sub_category);
        }

        const response = await apiClient.post(`/api/fs-brand-list`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching data:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};